export default "__VITE_ASSET__7tSwaRgI__"